
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"26","height":"26","viewBox":"0 0 26 26","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"13","cy":"13","r":"13","fill":"#C91919"}}),_c('path',{attrs:{"d":"M7.835 5.7c-.627 0-1.134.507-1.134 1.133v11.334c0 .626.507 1.133 1.134 1.133h7.933c.626 0 1.133-.507 1.133-1.133V6.833c0-.626-.507-1.133-1.133-1.133H7.835zm10.062.384c.084.236.138.485.138.75v11.333a2.26 2.26 0 01-.666 1.602l.42.067c.618.097 1.199-.325 1.297-.943l1.768-11.194a1.133 1.133 0 00-.942-1.297l-2.015-.318zm-6.096 2.45c.117 0 .22.043.31.103l.027.007c1.005.819 3.063 2.848 3.063 4.14a1.983 1.983 0 01-1.983 1.983 1.96 1.96 0 01-1.208-.422c.292.777.75 1.255 1.314 1.575v.001a.283.283 0 01-.106.546h-2.834a.283.283 0 01-.106-.546v-.001c.563-.32 1.023-.798 1.314-1.575a1.96 1.96 0 01-1.208.422 1.983 1.983 0 01-1.983-1.984c0-1.291 2.058-3.32 3.064-4.139l.026-.007a.552.552 0 01.31-.104z","fill":"#fff"}})])
          )
        }
      }
    